import type { RouteRecordRaw } from 'vue-router';

export default {
    path: '/app/onboarding',
    name: 'onboarding',
    component: () => import('./FirstTimeOnboarding.vue'),
} satisfies RouteRecordRaw;
